export const TAB_INITIAL_HEIGHT = '50px';
export const TAB_INITIAL_HEIGHT_MOBILE = '50px';
export const TAB_HIDDEN_PIXELS = '68px';
export const TAB_OFFSET = '2px';
export const DESKTOP_PADDING = '32px';
export const MOBILE_PADDING = '16px';
export const TOTAL_DESKTOP_PADDING = 64;
export const TOTAL_MOBILE_PADDING = 32;

export const WRAPPER = '100vw';
export const GUTTER = '100px';
export const GRID_IMAGE_SIZE = 72;
export const MOBILE_GRID_IMAGE_SIZE = 72;
export const DESKTOP_GRID_IMAGE_SIZE = 90;
export const NUM_OF_COLUMNS = 4;
export const NUM_OF_GUTTERS = 3;
export const ROW_HEIGHT = `calc((${WRAPPER} - (${NUM_OF_GUTTERS} * ${GUTTER})) / ${NUM_OF_COLUMNS})`;
export const MOBILE_GUTTER = '50px';
export const MOBILE_NUM_OF_COLUMNS = 2;
export const MOBILE_NUM_OF_GUTTERS = 1;
export const MOBILE_ROW_HEIGHT = `calc((${WRAPPER} - (${MOBILE_NUM_OF_GUTTERS} * ${MOBILE_GUTTER})) / ${MOBILE_NUM_OF_COLUMNS})`;

export const DESKTOP_CARD_MARGIN = 24;
export const MOBILE_CARD_MARGIN = '8px';
export const NUM_ALLOWED_OF_CATEGORY_CARDS = 4;

export const DESKTOP_TOTAL_HORIZONTAL_MODULE_PADDING = '64px';
export const MOBILE_TOTAL_HORIZONTAL_MODULE_PADDING = '32px';

export const MOBILE_PRODUCT_CAROUSEL_ROW_IMAGE_SIZE = 128;
export const DESKTOP_PRODUCT_CAROUSEL_ROW_IMAGE_SIZE = 192;

export const DESKTOP_CATEGORY_CARD_WIDTH = `calc((100vw - ${DESKTOP_TOTAL_HORIZONTAL_MODULE_PADDING} - ${
  DESKTOP_CARD_MARGIN * (NUM_ALLOWED_OF_CATEGORY_CARDS - 1)
}px) / ${NUM_ALLOWED_OF_CATEGORY_CARDS})`;

export const ORIENTATION_STYLES = Object.freeze({
  top_left: `
    top: 0;
    left: 0;
    margin-top: -20px;
    `,
  top_center: `
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    margin-top: -20px;
    `,
  top_right: `
    top: 0;
    right: 0;
    margin-top: -20px;
    `,
  middle_left: `
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    `,
  middle_center: `
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    `,
  middle_right: `
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    `,
  bottom_left: `
    bottom: 0;
    left: 0;
    margin-bottom: -20px;
    `,
  bottom_center: `
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    margin-bottom: -20px;
    `,
  bottom_right: `
    bottom: 0;
    right: 0;
    margin-bottom: -20px;
    `,
});
